import type { IMeasureService } from './IMeasureService';
import type {
  ApiMeasureParams,
  ApiReturnMeasuresValidated,
} from '@highimpact-frontend/api-types';
import { api_data_dasboard } from '../../../api-commons';

class MeasureService implements IMeasureService {
  async get(params: {
    site_id: number;
    t0: string;
    t1: string;
    device_ids: number[];
  }): Promise<ApiReturnMeasuresValidated> {
    const url = this.getUrlForGet(params);
    const response = await api_data_dasboard.get(url);
    return response.data;
  }
  getUrlForGet({
    site_id,
    t0,
    t1,
    device_ids,
  }: {
    site_id: number;
    t0: string;
    t1: string;
    device_ids: number[];
  }): string {
    const queryParams = device_ids.map((id) => `device_id=${id}`).join('&');
    return `/measures/sites/${site_id}/${t0}/${t1}${
      device_ids.length > 0 ? `?${queryParams}` : ''
    }`;
  }
  async put(id: number, measureParams: ApiMeasureParams): Promise<string> {
    const response = await api_data_dasboard.put(
      `/measures?id=${id}`,
      measureParams
    );
    return response.data;
  }
  async delete(id: number): Promise<string> {
    const response = await api_data_dasboard.delete(`/measure?id=${id}`);
    return response.data;
  }
}

const instance = new MeasureService();
export default instance;
